<div class="empty-state" [class.empty-state--compact]="compact" [class.empty-state--inline]="inline" role="status">
  <div class="empty-state__image-wrapper" *ngIf="imageSrc; else iconEmptyState" aria-hidden="true">
    <img class="empty-state__image" [src]="imageSrc" [alt]="title" />
  </div>
  <ng-template #iconEmptyState>
    <div class="empty-state__icon-wrapper" aria-hidden="true">
      <div class="empty-state__icon-ring"></div>
      <div class="empty-state__icon">
        <svg class="empty-state__svg-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path [attr.d]="iconPath" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
    </div>
  </ng-template>
  <div class="empty-state__title">{{ title }}</div>
  <div class="empty-state__description" *ngIf="description">{{ description }}</div>
</div>
